<div class="container flex justify-content-center align-items-center h-screen bg-light mt-4">
    <div class="uWrapper" *ngIf="userVerified ">
        <h3>Email Verified successfully!</h3>
        <div class="mt-3 flex justify-content-center">
            <button pButton type="button" label="Login" routerLink="/login" ></button>
        </div>
        
    </div>
</div>
